// 模拟API响应
const mockResponse = (data, delay = 500) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        code: 200,
        data: data,
        msg: 'success'
      })
    }, delay)
  })
}

// 设置封面图片
export function setCoverPicture(params) {
  console.log('设置封面图片:', params)
  return mockResponse({
    id: Date.now(),
    url: params.url,
    type: params.type
  })
}

// 重新转码
export function redoOffice(nodeId, contentId) {
  console.log('重新转码:', { nodeId, contentId })
  return mockResponse({
    id: contentId,
    status: 'processing'
  })
}

// 删除PDF图片
export function deletePdfImg(imgId) {
  console.log('删除PDF图片:', imgId)
  return mockResponse({
    id: imgId,
    deleted: true
  })
}

// 上传预览图片
export function uploadPreviewImg(nodeId, contentId, formData) {
  console.log('上传预览图片:', { nodeId, contentId, formData })
  return mockResponse({
    id: Date.now(),
    url: 'https://via.placeholder.com/300x200',
    name: 'uploaded-image.jpg'
  })
}

// 裁剪图片
export function cropper(data) {
  console.log('裁剪图片:', data)
  return mockResponse({
    id: data.id,
    url: data.url,
    width: data.width,
    height: data.height,
    x: data.x,
    y: data.y
  })
} 